<template>
    <div class="main-container">
        <div class="filter-container">
            <SelectChannel v-if="filters.channel_genre==ChannelGenres['对外渠道']" style="width: 250px;" v-model="filters.channel_name" @channelChange="onChannelChange" />
            <el-input v-if="filters.channel_genre==ChannelGenres['销售渠道']" class="filter-item" v-model="filters.channel_name" placeholder="渠道名称" size="default"></el-input>
            <el-input v-if="filters.channel_genre==ChannelGenres['对外渠道']" class="filter-item" v-model="filters.channel_no" placeholder="渠道号"></el-input>
            <el-input v-if="filters.channel_genre==ChannelGenres['对外渠道']" class="filter-item" v-model="filters.sale_user_name" placeholder="销售"></el-input>
            <el-input v-if="filters.channel_genre==ChannelGenres['销售渠道']" class="filter-item" v-model="filters.saler" placeholder="销售名称"></el-input>
            <el-select v-if="filters.channel_genre==ChannelGenres['对外渠道']" class="filter-item" v-model="filters.status" placeholder="状态">
                <el-option label="上架" value="1"></el-option>
                <el-option label="下架" value="0"></el-option>
            </el-select>
            <el-select v-if="filters.channel_genre==ChannelGenres['对外渠道']" class="filter-item" v-model="filters.afterknot" placeholder="结算类型">
                <el-option label="全部" value="0"></el-option>
                <el-option label="后结算" value="1"></el-option>
                <el-option label="预付款" value="2"></el-option>
            </el-select>
            <el-date-picker v-if="filters.channel_genre==ChannelGenres['对外渠道']" class="filter-item" v-model="filters.start_time" value-format="YYYY-MM-DD" placeholder="结算开始时间"></el-date-picker>
                <span v-if="filters.channel_genre==ChannelGenres['对外渠道']" class="filter-divider">-</span>
            <el-date-picker v-if="filters.channel_genre==ChannelGenres['对外渠道']" class="filter-item" v-model="filters.end_time" value-format="YYYY-MM-DD" placeholder="结算结束时间"></el-date-picker>
            <el-button class="filter-item" type="primary" @click="onSearch">搜索</el-button>
            <!-- 添加权限验证 -->
            <!-- <el-button class="filter-item" type="primary" v-permission="'添加渠道'">添加渠道</el-button> -->
            <el-button class="filter-item" type="primary" v-if="filters.channel_genre==ChannelGenres['销售渠道'] && !groupArray.includes('5')" @click="router.push(`/channel/edit?channel_genre=${filters.channel_genre}`)">添加渠道</el-button>
            <el-button class="filter-item" type="primary" v-if="!groupArray.includes('5') && path!=1" @click="router.push('/channel/contract-warning')">合同提醒</el-button>
        </div>
        <el-table :data="channelList" stripe border style="width:100%" v-loading="tableLoading">
            <el-table-column type="index"></el-table-column>
            <template v-if="filters.channel_genre==ChannelGenres['对外渠道']">
                <el-table-column prop="channel_name" label="渠道名称"></el-table-column>
                <el-table-column prop="channel_no" label="渠道编号"></el-table-column>
                <el-table-column label="对接类型">
                    <template #default="scope">
                        <span v-if="scope.row.type == 1">API对接</span>
                        <span v-if="scope.row.type == 2">H5对接</span>
                        <span v-if="scope.row.type == 3">特殊对接</span>
                    </template>
                </el-table-column>
                <el-table-column label="结算类型">
                    <template #default="scope">
                        <span v-if="scope.row.afterknot == 1">后结算</span>
                        <span v-else>预付款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_discount" label="折扣"></el-table-column>
                <el-table-column prop="channel_remain_money" label="剩余金额"></el-table-column>
                <el-table-column prop="offline_money" label="下线金额"></el-table-column>
                <el-table-column prop="stl_time" label="结算日期"></el-table-column>
                <!-- <el-table-column prop="home_page_url" label="首页地址" width="200"></el-table-column> -->
                <el-table-column label="状态" width="60">
                    <template #default="scope">
                        <span v-if="scope.row.channel_status == 1">上架</span>
                        <span v-else type="info">下架</span>
                    </template>
                </el-table-column>
            </template>
            <template v-else-if="filters.channel_genre==ChannelGenres['销售渠道']">
                <el-table-column prop="company_all" label="渠道名称"></el-table-column>
                <el-table-column prop="saler" label="销售人员"></el-table-column>
                <el-table-column prop="type" label="默认页面">
                    <template #default="scope">
                        <span v-if="scope.row.type == 1">蛋糕页</span>
                        <span v-else type="info">首页</span>
                    </template>
                </el-table-column>
                <el-table-column prop="discount" label="折扣"></el-table-column>
            </template>
            <el-table-column v-if="filters.channel_genre==ChannelGenres['对外渠道']" prop="channel_xs_name" label="销售"></el-table-column>
            <el-table-column v-if="filters.channel_genre==ChannelGenres['对外渠道']" prop="channel_yy_name" label="运营"></el-table-column>
            <el-table-column label="操作" width="157" fixed="right">
                <!-- group：1-超级管理员，5-财务，20-销售，70-销售经理 -->
                <template #default="scope">
                    <div class="action-list">
                        <!-- <el-button style="margin-bottom: 10px" type="primary" size="small" v-if="filters.channel_genre==ChannelGenres['销售渠道']" @click="pageSet(scope.row)" >页面配置</el-button> -->
                        <el-button type="primary" size="small" v-if="path==1" @click="onEdit(scope.row,path)">查看</el-button>
                        <el-button type="primary" size="small" v-if="path==1 && groupArray.includes('1')" @click="toPrepayEdit(scope.row)">预付款变动</el-button>
                        <el-button type="primary" size="small" v-if="!groupArray.includes('5') && path!=1 && !(filters.channel_genre == ChannelGenres['销售渠道'] && (groupArray.includes('20') || groupArray.includes('70')))"  @click="onEdit(scope.row,path)">编辑</el-button>
                        <el-button type="primary" size="small" v-if="groupArray.includes('5')"  @click="setRecharge(scope.row)">充值</el-button>
                        <el-button type="primary" size="small" v-if="filters.channel_genre==ChannelGenres['对外渠道'] && groupArray.includes('5')"  @click="toRechargeSetting(scope.row)">付款设置</el-button>
                        <el-dropdown v-if="!groupArray.includes('5') && path!=1 && !(filters.channel_genre == ChannelGenres['销售渠道'] && (groupArray.includes('20') || groupArray.includes('70')))">
                            <el-button type="primary" size="small">
                                更多 <i class="el-icon-arrow-down"></i>
                            </el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-if="filters.channel_genre==ChannelGenres['对外渠道']" @click="toBlock(scope.row)">品牌/商品屏蔽</el-dropdown-item>
                                    <el-dropdown-item v-if="filters.channel_genre==ChannelGenres['销售渠道']" @click="toOpen(scope.row)">开放/屏蔽设置</el-dropdown-item>
                                    <!-- <el-dropdown-item @click="brandDialogVisible=true;currChannel=scope.row,setOpenBrand(scope.row)">特殊品牌/商品开放</el-dropdown-item> -->
                                    <el-dropdown-item @click="toSpecialOpen(scope.row)">特殊品牌/商品开放</el-dropdown-item>
                                    <el-dropdown-item @click="couponLimitDialogVisible=true,currChannel=scope.row,setCouponLimit(scope.row)">电子券限制</el-dropdown-item>
                                    <el-dropdown-item @click="channelOutput(scope.row)">导出</el-dropdown-item>
                                    <template v-if="filters.channel_genre==ChannelGenres['对外渠道']">
                                        <el-dropdown-item @click="router.push(`/channel/single-channel-service-rate?channel_no=${scope.row.channel_no}&channel_name=${scope.row.channel_name}`)"> 
                                            <span class="dropdown-item-content">
                                            查看服务费率
                                            <!-- <el-badge :value="scope.row.jb_service_fee" :max="9999" class="badge"></el-badge> -->
                                            </span>
                                        </el-dropdown-item>
                                        <el-dropdown-item @click="toRechargeSetting(scope.row)">付款设置</el-dropdown-item>
                                        <!-- <el-dropdown-item @click="toBaseBrand(scope.row)">基础品牌池</el-dropdown-item> -->
                                        <el-dropdown-item
                                            @click="toDiscount(scope.row)"
                                            :disabled="scope.row.channel_no=='qixin'"
                                            :title="scope.row.channel_no=='qixin' ? '齐心渠道定制需求，品牌折扣不允许修改' : ''">
                                            品牌折扣
                                        </el-dropdown-item>
                                        <el-dropdown-item @click="changeStatus(scope.row)">{{scope.row.channel_status==1 ? '下架' : "上架" }}</el-dropdown-item>
                                        <el-dropdown-item @click="currChannel=scope.row,setOpenCoupon(scope.row)">电子券屏蔽</el-dropdown-item>
                                        <!-- <el-dropdown-item @click="setChannelAccounts(scope.row)">结算配置</el-dropdown-item>
                                        <el-dropdown-item @click="showChannelAccounts(scope.row)">查看当前结算信息</el-dropdown-item> -->
                                        <el-dropdown-item @click="router.push(`/channel/theme?channel_id=${scope.row.id}&type=${scope.row.type}&channel_name=${scope.row.channel_name}`)">主题配置</el-dropdown-item>
                                        <el-dropdown-item @click="router.push(`/couponline/product-list?channel_id=${scope.row.id}&channel_name=${scope.row.channel_name}`)">渠道电子券</el-dropdown-item>
                                        <template  v-if="scope.row.channel_no == 'h5'">
                                            <el-dropdown-item @click="router.push(`/channel/out-list-center?channel_no=${scope.row.channel_no}&channel_name=${scope.row.channel_name}`)">个人中心配置</el-dropdown-item>
                                        </template>
                                        <template v-if="JoinType[scope.row.type]=='H5对接'">
                                            <el-dropdown-item @click="router.push(`/channel/brand-sort?channel_no=${scope.row.channel_no}`)">品牌馆</el-dropdown-item>
                                            <el-dropdown-item @click="router.push(`/channel/product-sort?channel_no=${scope.row.channel_no}`)">商品排序</el-dropdown-item>
                                        </template>
                                        <el-dropdown-item @click="router.push(`/channel/contract-edit?id=${scope.row.contract_id || 0}&channel_no=${scope.row.channel_no}&channel_name=${scope.row.channel_name}&v=0`)">合同上传</el-dropdown-item>
                                    </template>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />

        <!-- 特殊品牌/商品开放 -->
        <el-dialog :close-on-click-modal="false" title="特殊品牌/商品开放" v-model="brandDialogVisible" @close="selectedOpenBrandList = []; selectedOpenProductList = []">
            <el-form>
                <el-form-item label="开放品牌">
                    <el-select v-model="selectedOpenBrandList" filterable multiple placeholder="请选择开放品牌">
                        <el-option
                            v-for="item in openBrandList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开放商品">
                    <el-select v-model="selectedOpenProductList" filterable multiple placeholder="请选择开放商品">
                        <el-option
                            v-for="item in openProductList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id + ''">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <div>
                    <el-button @click="brandDialogVisible = false;">取消</el-button>
                    <el-button type="primary" @click="saveOpenBrand()">保存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 电子券屏蔽弹框 -->
        <el-dialog :close-on-click-modal="false" title="屏蔽电子券" v-model="couponDialogVisible">
            <el-select v-model="selectedBrandList" filterable multiple placeholder="请选择">
                <el-option
                    v-for="item in brandList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <template #footer>
                <div>
                    <el-button @click="couponDialogVisible = false; selectedBrandList = []">取消</el-button>
                    <el-button type="primary" @click="saveOpenCoupon()">保存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 电子券数量限制 -->
        <el-dialog :close-on-click-modal="false" title="电子券数量限制" v-model="couponLimitDialogVisible">
            <el-table :data="couponList" border>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="coupons_info[0].name" label="电子券名称">
                    <template #default="scope">
                        {{ scope.row.coupons_info[0].name }}
                    </template>
                </el-table-column>
                <el-table-column prop="limit" label="限制数量" width="100">
                    <template #default="scope">
                        <el-input v-model="scope.row.limit" size="small"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template #default="scope">
                        <div class="action-list">
                            <el-button type="warning" @click="onDel(scope.row)" size="small">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <h2>新增限制</h2>
            <el-row>
                <el-col :span="9">
                    <el-select v-model="selectedCouponList" filterable multiple placeholder="请选择">
                        <el-option
                            v-for="item in allCountList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-input v-model.number="couponLimit" placeholder="请输入限制数量"></el-input>
                </el-col>
            </el-row>
            <template #footer>
                <div>
                    <el-button @click="couponLimitDialogVisible = false; selectedCouponList = []">取消</el-button>
                    <el-button type="primary" @click="saveCouponLimit()">保存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 结算详情 -->
        <el-dialog title="结算详情" v-model="accountsDialogVisible">
            <el-form>
                <el-form-item label="渠 道&nbsp&nbsp号" prop="channel_no">
                    <el-input v-model.trim="channelAccountInfo.channel_no" ></el-input>
                </el-form-item>
                <el-form-item label="服务加点" prop="service_discount">
                    <el-input v-model.trim="channelAccountInfo.service_discount" ></el-input>
                </el-form-item>
                <el-form-item label="结算折扣" prop="shop_discount">
                    <el-input v-model.number="channelAccountInfo.shop_discount"></el-input>
                </el-form-item>
                <el-form-item label="结算类型" prop="discount_type">
                    <el-select v-model="channelAccountInfo.discount_type" placeholder="请选择结算类型">
                        <el-option
                            v-for="item in discountTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间" prop="start_at">
                    <div class="block">
                        <!-- <span class="demonstration">With shortcuts</span> -->
                        <el-date-picker
                        v-model="channelAccountInfo.start_at"
                        type="datetime"
                        placeholder="生效时间"
                        >
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="失效时间" prop="end_at">
                    <div class="block" >
                        <!-- <span class="demonstration">With shortcuts</span> -->
                        <el-date-picker
                        v-model="channelAccountInfo.end_at"
                        type="datetime"
                        placeholder="失效时间"
                        disabled
                        >
                        </el-date-picker>
                    </div>
                </el-form-item>
            </el-form>
            <template #footer>
                <div>
                    <el-button @click="accountsDialogVisible = false; channelAccountInfo = []">取消</el-button>
                </div>
            </template>
        </el-dialog>
         <!-- 充值弹框 -->
         <el-dialog title="充值" v-model="rechargeDialogVisible" style="width:40%">
            <el-form :model="formRecharge" :rules="moneyRule" label-width="120px">
                <el-form-item label="金额" prop="money" >
                <el-input type="number" v-model="formRecharge.money">
                    <template #append>元</template>
                </el-input>
                </el-form-item>
                <el-form-item v-if="afterknot == 1" label="结算日期" prop="stl_time">
                    <el-date-picker class="input-item" v-model="formRecharge.stl_time" type="date"
                            value-format="YYYY-MM-DD" placeholder="结算日期"></el-date-picker>
                </el-form-item>
                <el-form-item v-if="afterknot == 1" label="下一结算日期" prop="next_stl_time">
                    <el-date-picker class="input-item" v-model="formRecharge.next_stl_time" type="date"
                            value-format="YYYY-MM-DD" placeholder="下一结算日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" maxlength="100" :rows="4" show-word-limit v-model="formRecharge.remark">
                    </el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <div>
                    <el-button @click="rechargeDialog">取消</el-button>
                    <el-button type="primary" @click="saveRecharge(formRecharge.id)">保存</el-button>
                </div>
            </template>
        </el-dialog>
        <!-- 页面配置弹框 -->
        <el-dialog title="设置默认页面" v-model="pageSetDialogVisible" style="width:40%">
            <el-form :model="formPageSet" label-width="120px">
                <el-form-item label="页面：" prop="type" >
                    <el-radio-group v-model="formPageSet.type">
                        <el-radio :value="0" label="首页" />
                        <el-radio :value="1" label="蛋糕页" />
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template #footer>
                <div>
                    <el-button @click="pageSetClose">取消</el-button>
                    <el-button type="primary" @click="savePageSet">保存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 预付款变动弹框 -->
        <el-dialog title="预付款变动" v-model="prepayDialogVisible" style="width:90%" @close="prepayClose"> 
            <el-table :data="prepayInfo" border>
                <el-table-column prop="channel_no" label="渠道号" width="80px"></el-table-column>
                <el-table-column prop="order_id" label="订单ID" width="100px"></el-table-column>
                <el-table-column prop="order_no" label="订单号"></el-table-column>
                <el-table-column prop="user_id" label="购买人ID" width="100px"></el-table-column>
                <el-table-column prop="mobile_phone" label="购买人电话"></el-table-column>
                <el-table-column prop="out_order_no" label="外部订单号"></el-table-column>
                <el-table-column prop="order_type" label="订单类型" width="50px">
                    <template #default="scope">
                        {{ scope.row.order_type == 1 ? '实物' : '其他' }}
                    </template>
                </el-table-column>
                <el-table-column prop="money_type" label="金额类型" width="50px">
                    <template #default="scope">
                        {{ scope.row.money_type == 1 ? '充值' : scope.row.money_type == 2 ? '消费' : '退款' }}
                    </template>
                </el-table-column>
                <el-table-column prop="money" label="金额" width="80px"></el-table-column>
                <el-table-column prop="remain_money" label="预付款剩余"></el-table-column>
                <el-table-column prop="msg" label="信息"></el-table-column>
                <el-table-column prop="created_at" label="创建时间"></el-table-column>
            </el-table>
            <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                <Pagination 
                    :currentPage="prepayPage" 
                    :total="prepayTotal" 
                    :pageSize="prepayPageSize"
                    @pageChange="prepayOnPageChange" 
                    @sizeChange="prepayOnSizeChange" 
                />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { defineComponent, getCurrentInstance, toRefs, reactive, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import { ActionTypes } from './enum'
import { ChannelGenres, JoinType } from '@/enums/channel'
import SelectChannel from '@/components/SelectChannel.vue'
import Pagination from '@/components/Pagination.vue'
import Keys from '@/constant/key'
import { getYufkConsumerApi } from '@/apis/channel'
import { joinParams } from '@/utils'

export default defineComponent({
name: 'ChannelList',
components: {Pagination,SelectChannel},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const groupString = store.state.user.userInfo.group_id
    const groupArray = groupString.split(',')
    const moneyRule = reactive({
        money:[
            { required: true, message: '请输入预付款金额', trigger: 'blur'}
        ],
        stl_time:[
            { required: true, message: '请输入结算日期', trigger: 'change'}
        ],
        next_stl_time:[
            { required: true, message: '请输入下一结算日期', trigger: 'change'}
        ],
    })
    const data = reactive({
        filters: {
            channel_name:   '',
            channel_no:     '',
            sale_user_name: '',
            status:         '',
            channel_genre:  '',
            saler:          '',
            start_time:     '',
            end_time:       '',
            afterknot:      '',//结算类型
        },
        badge: 'unCheckProduct', // 这里设置你的 badge 内容
        tableLoading:               false,      // 表格数据加载状态
        formRecharge: {
            money:      '',                     //预付款
            remark:     '',                     //备注
            stl_time :'',                       //结算日期
            next_stl_time:'',                   //下一结算日期
        },
        formPageSet: {
            sale_channel:      '',                     //渠道名
            type:     '',                     //类型
        },
        afterknot:'',                           //判断结算类型
        requestUrl: '',
        channelList:                [],         // 渠道列表
        currChannel:                '',         // 当前操作渠道信息
        total:                      0,
        page_size:                   10,
        page:                       1,

        brandDialogVisible:         false,      // 开放品牌弹框
        openBrandList:              [],         // 开放品牌列表
        openProductList:            [],         // 开放商品列表
        selectedOpenBrandList:      [],         // 已选择特殊开放品牌列表
        selectedOpenProductList:    [],         // 已选择特殊开放商品列表
        
        couponLimitDialogVisible:   false,      // 电子券限制弹框
        couponList:                 [],         // 电子券限制弹框-已限制电子券列表
        allCountList:               [],         // 所有电子券列表
        selectedCouponList:         [],         // 电子券限制弹框-新增电子券列表
        couponLimit:                0,

        couponDialogVisible:        false,      // 品牌-电子券屏蔽弹框
        rechargeDialogVisible:      false,      //预付款充值弹窗
        pageSetDialogVisible:      false,      //页面配置弹窗
        brandList:                  [],         // 品牌列表
        selectedBrandList:          [],         // 选中品牌列表

        detailLoading:              false,      // 详情接口加载状态
        accountsDialogVisible:      false,      //结算详情
        channelAccountInfo:         [],         //结算详情信息
        discountTypeList:           [],         //结算类型
        path:                       route.fullPath === '/partner/out-list' ? 1:0,
        prepayDialogVisible:        false,      //预付款变动弹窗
        prepayInfo:                 [],         
        prepayPage:                 1,        
        prepayPageSize:             10,         
        prepayTotal:                0,         
        // 设置请求参数
        setRequireOptions: () => {
            if (route.fullPath === '/channel/out-list' || route.fullPath === '/partner/out-list' ) {
                data.filters.channel_genre = ChannelGenres['对外渠道']
                data.requestUrl = '/dsapi/trade/channel_list'
            } else if (route.fullPath === '/channel/sale-list') {
                data.filters.channel_genre = ChannelGenres['销售渠道']
                data.requestUrl = '/dsapi/trade/channel_sale_list'
            }
        },
        //设置预付款
        saveRecharge: (id) => {
            data.formRecharge.id = id
            const { money, stl_time, next_stl_time } = data.formRecharge
            if(!stl_time && data.afterknot==1 || !next_stl_time && data.afterknot==1){
                return proxy.$message({ type: 'error', message: '请选择结算周期' })
            }
            proxy.$http.post('/admin/channel/recharge_money',data.formRecharge).then(res => {
                if(res.code == 200){
                    proxy.$message({ type: 'success', message: res.msg })
                    data.rechargeDialogVisible = false
                    data.getChannelList()
                }else{
                    proxy.$message({ type: 'error', message: res.msg })
                } 
            })
        },
        //页面配置
        savePageSet: (id) => {
            data.formRecharge.id = id
            const { type } = data.formPageSet
            proxy.$http.post('/channel/setChannelPage',data.formPageSet).then(res => {
                if(res.code == 200){
                    proxy.$message({ type: 'success', message: res.msg })
                    data.pageSetDialogVisible = false
                    data.getChannelList()
                }else{
                    proxy.$message({ type: 'error', message: res.msg })
                } 
            })
        },
        // handleInput: (value) => {
        //     // 使用正则表达式验证输入的值是否符合两位小数的格式
        //     const regex = /^\d+(\.\d{0,2})?$/;
        //     if (!regex.test(value)) {
        //     // 如果不符合要求，则截取前两位小数
        //     const newValue = parseFloat(value).toFixed(2);
        //     // 更新表单绑定的值
        //     data.formRecharge.money = newValue;
        //     }
        // },
        // 获取结算模板列表
        getChannelAccountsInfo: () => {
            proxy.$http.get(`dsapi/trade/account_template_list`).then(res => {
                if (res.code == 200) {
                    data.discountTypeList = res.data.discount_type
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },

        //获取当前渠道结算配置的信息
        showChannelAccounts:(row)=>{
            data.accountsDialogVisible = true;
            proxy.$http.get(`port/channel/getNowChannelAccountsInfo?channel_no=${row.channel_no}`).then(res => {
                if (res.code == 0) {
                    data.channelAccountInfo = res.data
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },

        // 编辑
        onEdit: (rowData,path) => {
            router.push(`/channel/edit?channel_id=${rowData.id}&channel_genre=${data.filters.channel_genre}&path=${path}`)
        },

        // 渠道上下架
        changeStatus: (rowData) => {
            let statusTxt = rowData.channel_status == 0 ? '上架' : '下架'
            let newStatus = rowData.channel_status ^ 1
            proxy.$confirm(`确定要 <b>${statusTxt}${rowData.channel_name}</b> 渠道吗？`, '提示', {
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                proxy.$http.get(`/dsapi/trade/channel_status?channel_id=${rowData.id}&status=${newStatus}&channel_genre=${data.filters.channel_genre}`).then(res => {
                    if (res.code == 200) {
                        proxy.$message({
                            type: 'success',
                            message: `${rowData.channel_name}渠道${statusTxt}成功！`
                        })
                        data.getChannelList()
                    } else {
                        proxy.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                })
            })
        },

        // 跳转到品牌屏蔽页
        toBlock: (row) => {
            const { id, channel_name } = row
            router.push(`/channel/block?channel_id=${id}&channel_name=${channel_name}&channel_genre=${data.filters.channel_genre}`)
        },
        // 跳转到开放屏蔽设置页
        toOpen: (row) => {
            const { id, channel_name } = row
            router.push(`/channel/ordinary-open?channel_id=${id}&channel_name=${channel_name}&channel_genre=${data.filters.channel_genre}`)
        },
        // 跳转到特殊品牌开放设置页
        toSpecialOpen: (row) => {
            const { id, channel_name, name } = row
            router.push(`/channel/open-special?channel_id=${id}&channel_genre=${data.filters.channel_genre}&channel_name=${channel_name}`)
        },
        // 跳转至渠道付款配置
        toRechargeSetting: (row) => {
            router.push(`/channel/recharge-setting?channel_id=${row.id}&channel_name=${row.channel_name}`)
        },

        // 跳转到基础品牌池
        toBaseBrand: (row) => {
            router.push(`/channel/base-brand?channel_id=${row.id}&channel_name=${row.channel_name}`)
        },

        // 跳转到品牌折扣配置页
        toDiscount: (row) => {
            router.push(`/channel/discount-brand?channel_id=${row.id}&channel_name=${row.channel_name}`)
        },

        // 保存屏蔽/开放信息接口
        saveShieldGoods: (params, type, callback) => {
            params.channel_id = data.currChannel.id
            params.channel_genre = data.filters.channel_genre
            params.type = ActionTypes[type]
            proxy.$http.post('/dsapi/trade/shield_goods', params).then(res => {
                if (res.code == 200) {
                    proxy.$message({
                        type: 'success',
                        message: `${type}成功`
                    })
                    if (callback) {
                        callback()
                    }
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },

        // 设置特殊品牌开放
        setOpenBrand: (rowData) => {
            data.getOpenBrandList().then(res => {
                data.openBrandList = res.brands
                data.openProductList = res.products
            })
            data.getChannelDetail(rowData.id, 1).then(res => {
                let brands_control = res.brands_control
                brands_control.forEach(item => {
                    if (item.product_ids) {
                        data.selectedOpenProductList = data.selectedOpenProductList.concat(item.product_ids.split(','))
                    } else {
                        data.selectedOpenBrandList.push(item.brands_id)
                    }
                })
            })
        },
        // 保存开放品牌
        saveOpenBrand: () => {
            let openProductList = data.openProductList
            let selectedOpenBrandList = data.selectedOpenBrandList
            let selectedOpenProductList = data.selectedOpenProductList
            let resultArr = []
            let params = {}
            selectedOpenBrandList.forEach(brandId => {
                resultArr.push({
                    brands_id: brandId,
                    products_ids: []
                })
            })
            // if (selectedOpenBrandList.length === 0 && selectedOpenProductList.length === 0) {
            //     return proxy.$message({
            //         type: 'error',
            //         message: '请选择开放品牌 或 开放商品'
            //     })
            // }
            if (selectedOpenProductList.length) {
                selectedOpenProductList.forEach(productId => {
                    let productItem = openProductList.find(item => item.id == productId)
                    let isNotExit = true
                    resultArr.forEach(brandItem => {
                        if (brandItem.brands_id === productItem.brand_id) {
                            brandItem.products_ids.push(productItem.id)
                            isNotExit = false
                            return
                        }
                    })
                    if (isNotExit) {
                        resultArr.push({
                            brands_id: productItem.brand_id,
                            products_ids: [productItem.id]
                        })
                    }
                })
            }
            resultArr.forEach(item => {
                item.products_ids = item.products_ids.join(',')
            })
            params.brands_info = resultArr

            if (params.brands_info.length === 0) {
                proxy.$confirm('当前未选择品牌/商品，将清空该渠道所有特殊开放品牌/商品，确定要进行此操作吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    data.saveShieldGoods(params, '特殊品牌开放', () => {
                        data.brandDialogVisible = false
                    })
                }).catch(() => {
                    console.log('取消开放')
                })
            } else {
                data.saveShieldGoods(params, '特殊品牌开放', () => {
                    data.brandDialogVisible = false
                })
            }
        },
        
        // 设置电子券屏蔽
        setOpenCoupon: (row) => {
            data.getChannelDetail(row.id, 2).then(res => {
                res.brands_control.map(item => {
                    data.selectedBrandList.push(item.brands_id)
                })
            })
            data.getBrandList()
            data.couponDialogVisible = true
        },
        //预付款充值弹窗
        setRecharge:(row) => {
            data.formRecharge.id = row.id
            data.afterknot = row.afterknot
            data.formRecharge.money = ''
            data.formRecharge.remark = ''
            data.setRequireOptions()
            data.rechargeDialogVisible = true
        },
        rechargeDialog:() => {
            data.rechargeDialogVisible = false
            data.formRecharge.money = ''
            data.formRecharge.remark = ''
            data.formRecharge.stl_time = ''
            data.formRecharge.next_stl_time = ''
        },
        //页面配置弹窗
        pageSet:(row) => {
            data.formPageSet.type = row.type
            data.formPageSet.sale_channel = row.channel_name
            data.pageSetDialogVisible = true
        },
        pageSetClose:() => {
            data.pageSetDialogVisible = false
            data.formPageSet.type = ''
            data.formPageSet.sale_channel = ''
        },
        // 保存屏蔽品牌电子券数据
        saveOpenCoupon: () => {
            let params = {}
            params.brands_info = []
            data.selectedBrandList.map(item => {
                params.brands_info.push({
                    brands_id: item,
                    products_ids: [],
                    is_del: 1
                })
            })
            data.saveShieldGoods(params, '电子券屏蔽', () => {
                data.couponDialogVisible = false
            })
        },

        // 设置电子券数量限制
        setCouponLimit: (row) => {
            data.getChannelDetail(row.id, 3).then(res => {
                data.couponList = res.brands_control
            })
            data.getCouponList()
        },
        // 删除电子券限制
        onDel: (row) => {
            proxy.$confirm(`确定要删除 <b>${row.coupons_info[0].name}</b> ？`, '提示', {
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                data.couponList.map((item, index) => {
                    if (item.id == row.id) {
                        data.couponList.splice(index, 1)
                    }
                })
                data.saveCouponLimit(1)
            }).catch(() => {
                console.log('已取消')
            })
        },
        // 保存电子券数量限制数据
        saveCouponLimit: (type) => {
            let params = {}
            let tmpTableData = JSON.parse(JSON.stringify(data.couponList || [])) // 解决改变 tmpTableData 时，couponTableData 同时改变的问题

            if (data.selectedCouponList.length && data.couponLimit !== '') {
                data.selectedCouponList.map(item => {
                    tmpTableData.map((subItem, index) => {
                        if (subItem.coupons_ids == item) {
                            tmpTableData.splice(index, 1)
                        }
                    })
                    tmpTableData.push({
                        coupons_ids: item,
                        limit: data.couponLimit,
                        is_del: 1
                    })
                })
            } else if (data.selectedCouponList.length && data.couponLimit === '') {
                return proxy.$message({
                    type: 'error',
                    message: '请输入新增电子券限制数量'
                })
            }

            params.coupons_info = tmpTableData

            data.saveShieldGoods(params, '电子券限制', () => {
                data.selectedCouponList = []
                data.couponLimit = 0
                if(type==1){
                    data.couponLimitDialogVisible = true
                }else{
                    data.couponLimitDialogVisible = false        
                }
            })
        },

        // 获取开放品牌及商品
        getOpenBrandList: () => {
            return new Promise((resolve, reject) => {
                proxy.$http.get(`channel/special_open_list`).then(res => {
                    if (res.code == 200) {
                        resolve(res.data)
                    } else {
                        reject(res.msg)
                    }
                })
            })
        },
        // 获取渠道列表
        getChannelList: () => {
            data.tableLoading = true
            if(data.filters.start_time == null || data.filters.end_time == null){
                data.filters.start_time =''
                data.filters.end_time = ''
            }
            proxy.$http.get(`${data.requestUrl}?channel_name=${data.filters.channel_name}&channel_no=${data.filters.channel_no}&status=${data.filters.status}&saler=${data.filters.saler}&start_time=${data.filters.start_time}&end_time=${data.filters.end_time}&sale_user_name=${data.filters.sale_user_name}&afterknot=${data.filters.afterknot}&&page=${data.page}&page_size=${data.page_size}`).then(res => {
                if (res.code == 200) {
                    data.channelList = res.data.data
                    data.total = res.data.total
                    data.tableLoading = false
                } else {
                    data.tableLoading = false
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 获取渠道详情
        getChannelDetail: (id, type) => {
            return new Promise((resolve, reject) => {
                proxy.$http.get(`/dsapi/trade/channel_details?channel_id=${id}&type=${type}&channel_genre=${data.filters.channel_genre}`).then((res) => {
                    if (res.code == 200) {
                        resolve(res.data)
                    } else {
                        proxy.$message({
                            type: 'error',
                            message: res.msg
                        })
                        reject(res.msg)
                    }
                })
            })
        },
        // 获取品牌电子券
        getCouponList: () => {
            proxy.$http.get(`dsapi/trade/coupons_info`).then(res => {
                data.allCountList = res.data
            })
        },
        // 获取品牌列表
        getBrandList: () => {
            proxy.$http.get(`/dsapi/trade/brands_list?cat_id=4`).then(res => {
                if (res.code != 200) return proxy.$message({
                    type: 'error',
                    message: res.msg
                })
                data.brandList = res.data
            })
        },
        // 搜索
        onSearch: () => {
            data.page = 1
            data.getChannelList()
        },
        // 导出
        channelOutput: (row) => {
            const {id} = row
            const {channel_genre} = data.filters
            window.open(`${Keys.baseUrl}/channel/channelRule?${joinParams({channel_genre,channel_id:id,user_id:store.state.user.userInfo.id,user_name:store.state.user.userInfo.username})}`)
        },
        // 翻页
        // onPageChange: (val) => {
        //     data.page = val
        //     data.getChannelList()
        // },
        onPageChange: (val) => {
            data.page = val
            data.getChannelList()
        },
        onSizeChange: (val) => {
            data.page_size = val
            data.getChannelList()
        },
        //结算配置
        setChannelAccounts:(row)=>{
            router.push(`/channel/channel-accountsList?channel_no=${row.channel_no}`);
        },
        // 预付款变动
        currChannelNo: '',
        getPrepayInfo: (page = 1, pageSize = 10) => {
            if (!data.currChannelNo) return
            getYufkConsumerApi({
                channel_no: data.currChannelNo,
                page: page,
                page_size: pageSize,
            }).then(res => {
                if (res.code == 200) {
                    data.prepayInfo = res.data.data
                    data.prepayTotal = res.data.total
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 预付款变动
        toPrepayEdit:(row)=>{
            data.currChannelNo = row.channel_no
            data.prepayPage = 1
            data.prepayPageSize = 10
            data.prepayDialogVisible = true
            data.getPrepayInfo(1, 10)
        },
        prepayClose: () => {
            data.prepayDialogVisible = false
        },
        // 预付款变动分页
        prepayOnPageChange: (val) => {
            data.prepayPage = val
            data.getPrepayInfo(val, data.prepayPageSize)
        },
        prepayOnSizeChange: (val) => {
            data.prepayPageSize = val
            data.prepayPage = 1
            data.getPrepayInfo(1, val)
        },
    })

    // 渠道变化监听
    const onChannelChange = (val) => {
        data.filters.channel_name = val ? val.channel_name : ''
    }
    // 监听路由变化，修改渠道类型, 并重新获取渠道数据
    // watch(() => route.fullPath, () => {
    //     window.location.reload()
    // })

    data.setRequireOptions()
    data.getChannelList()
    data.getChannelAccountsInfo()

    return { ...toRefs(data), ChannelGenres, JoinType, ActionTypes, router, groupArray,moneyRule,onChannelChange }
}
})
</script>

<style lang="stylus" scoped>
    h2
        font-size 14px
        font-weight bold
        margin 20px 0 15px
    :deep(.el-input-group)
         width: 245px;

    .dropdown-item-content {
    display: flex;
    align-items: center;
    }
    .badge {
    margin-left: 8px; /* 根据需要调整间距 */
    }
</style>